import { doAction, doResponseAction } from ".";

const ACCESS_CONTROL_SUPERVISORS = "ACCESS_CONTROL_SUPERVISORS";
const ACCESS_CONTROL_SUPERVISORS_SUCCESS = "ACCESS_CONTROL_SUPERVISORS_SUCCESS";
const ACCESS_CONTROL_SUPERVISORS_FAILURE = "ACCESS_CONTROL_SUPERVISORS_FAILURE";

const ACCESS_CONTROL_ADD_HOSTEL = "ACCESS_CONTROL_ADD_HOSTEL";
const ACCESS_CONTROL_ADD_HOSTEL_SUCCESS = "ACCESS_CONTROL_ADD_HOSTEL_SUCCESS";
const ACCESS_CONTROL_ADD_HOSTEL_FAILURE = "ACCESS_CONTROL_ADD_HOSTEL_FAILURE";

const ACCESS_CONTROL_REMOVE_HOSTEL = "ACCESS_CONTROL_REMOVE_HOSTEL";
const ACCESS_CONTROL_REMOVE_HOSTEL_SUCCESS = "ACCESS_CONTROL_REMOVE_HOSTEL_SUCCESS";
const ACCESS_CONTROL_REMOVE_HOSTEL_FAILURE = "ACCESS_CONTROL_REMOVE_HOSTEL_FAILURE";

const ACCESS_CONTROL_SUGGESTIONS = "ACCESS_CONTROL_SUGGESTIONS";
const ACCESS_CONTROL_SUGGESTIONS_SUCCESS = "ACCESS_CONTROL_SUGGESTIONS_SUCCESS";
const ACCESS_CONTROL_SUGGESTIONS_CLEAR = "ACCESS_CONTROL_SUGGESTIONS_CLEAR";

export {
    ACCESS_CONTROL_SUPERVISORS,
    ACCESS_CONTROL_SUPERVISORS_SUCCESS,
    ACCESS_CONTROL_SUPERVISORS_FAILURE,
    ACCESS_CONTROL_ADD_HOSTEL,
    ACCESS_CONTROL_ADD_HOSTEL_SUCCESS,
    ACCESS_CONTROL_ADD_HOSTEL_FAILURE,
    ACCESS_CONTROL_REMOVE_HOSTEL,
    ACCESS_CONTROL_REMOVE_HOSTEL_SUCCESS,
    ACCESS_CONTROL_REMOVE_HOSTEL_FAILURE,
    ACCESS_CONTROL_SUGGESTIONS,
    ACCESS_CONTROL_SUGGESTIONS_SUCCESS,
    ACCESS_CONTROL_SUGGESTIONS_CLEAR,
};

export const accessControlSupervisorList = (params, callback) =>
    doAction(ACCESS_CONTROL_SUPERVISORS, params, callback);
export const accessControlSupervisorListSuccess = (data = {}) =>
    doResponseAction(ACCESS_CONTROL_SUPERVISORS_SUCCESS, data);
export const accessControlSupervisorListFailure = (data = {}) =>
    doResponseAction(ACCESS_CONTROL_SUPERVISORS_FAILURE, data);

export const accessControlAddHostel = (params, callback) =>
    doAction(ACCESS_CONTROL_ADD_HOSTEL, params, callback);
export const accessControlAddHostelSuccess = (data = {}) =>
    doResponseAction(ACCESS_CONTROL_ADD_HOSTEL_SUCCESS, data);
export const accessControlAddHostelFailure = (data = {}) =>
    doResponseAction(ACCESS_CONTROL_ADD_HOSTEL_FAILURE, data);

export const accessControlRemoveHostel = (params, callback) =>
    doAction(ACCESS_CONTROL_REMOVE_HOSTEL, params, callback);
export const accessControlRemoveHostelSuccess = (data = {}) =>
    doResponseAction(ACCESS_CONTROL_REMOVE_HOSTEL_SUCCESS, data);
export const accessControlRemoveHostelFailure = (data = {}) =>
    doResponseAction(ACCESS_CONTROL_REMOVE_HOSTEL_FAILURE, data);

export const accessControlSuggestions = (params, callback) =>
    doAction(ACCESS_CONTROL_SUGGESTIONS, params, callback);
export const accessControlSuggestionsSuccess = (data = {}) =>
    doResponseAction(ACCESS_CONTROL_SUGGESTIONS_SUCCESS, data);
export const accessControlSuggestionsClear = () =>
    ({ type: ACCESS_CONTROL_SUGGESTIONS_CLEAR });
